import React, { lazy, Suspense } from "react";
import { Switch, Route } from "react-router-dom";
import Loading from 'components/shared-components/Loading';
import { APP_PREFIX_PATH } from 'configs/AppConfig'

export const AppViews = () => {
  return (
    <Suspense fallback={<Loading cover="content"/>}>
      <Switch>
          <Route exact path={`${APP_PREFIX_PATH}/`} component={lazy(() => import(`./home`))} />
          <Route path={`${APP_PREFIX_PATH}/users`} component={lazy(() => import(`./users`))} />
          <Route path={`${APP_PREFIX_PATH}/response`} component={lazy(() => import(`./response`))} />
          <Route path={`${APP_PREFIX_PATH}/reports`} component={lazy(() => import(`./reports`))} />
          <Route path={`${APP_PREFIX_PATH}/vehicles`} component={lazy(() => import(`./vehicles`))} />
          <Route path={`${APP_PREFIX_PATH}/purposes`} component={lazy(() => import(`./purposes`))} />
          <Route path={`${APP_PREFIX_PATH}/questions`} component={lazy(() => import(`./questions`))} />
          <Route path={`${APP_PREFIX_PATH}/routes`} component={lazy(() => import(`./routes`))} />
      </Switch>
    </Suspense>
  )
}

export default React.memo(AppViews);
